import $ from 'jquery';

// Provides this syntax:
// $(img).loadImage(someUrl);

$.fn.loadImage = function(newSrc) {
    var img = this,
        promise = $.Deferred();

    var successCallback = function(){
        img.off('load',  successCallback);
        img.off('error', failureCallback);
        promise.resolve(img);
    };

    var failureCallback = function(){
        img.unbind('load',  successCallback);
        img.unbind('error', failureCallback);
        promise.reject(img);
    };

    img.on('error', failureCallback);
    img.on('load',  successCallback);

    img.attr('src', newSrc);

    // If the url is cached and loaded,
    // call the callback by hand.
    //
    if (img[0]) {
        if (img[0].complete || img[0].readyState) {
            successCallback();
        }
    }

    // Return the promise
    //
    return promise;
};

// Provides two additional syntax's:
//
//   $.loadImage(imgEl, someUrl);
//   $.loadImage(someUrl);

$.loadImage = function(img, newSrc) {
    if ($.type(newSrc) == 'undefined') {
        var newSrc = img,
            img = $('<img />');
    } else {
        var img = $(img);
    }
    return img.loadImage(newSrc);
};



// WEBPACK FOOTER //
// ./src/web/js/app/lib/load-image.js